<div class="card shadow border-0 mb-5">
  <div class="card-body">

    <div class="d-flex flex-row align-items-center">
      <span class="text-cta h1 mb-0 fw-bold me-2">{{reviewsSummary.averageRating | number: '1.1-1'}}</span>
      <div class="d-flex flex-column">
        <app-rating-stars [clickable]="false"
                          [ratingValue]="reviewsSummary.averageRating"
                          [ratingStarsSize]="'lg'"></app-rating-stars>
        <span class="text-salon-reviews"
              [translate]="'SALON-DETAILS.REVIEWS-SECTION.BASED-ON'"
              [translateParams]="{reviewsCount: reviewsSummary.reviewsCount}">
        </span>
      </div>
    </div>
    <hr>

    <ng-container [ngTemplateOutlet]="partialGrade"
                  [ngTemplateOutletContext]="{rating:reviewsSummary.salonAverageRating,
                    translation: 'SALON-DETAILS.REVIEWS-SECTION.AVERAGE-PARTIAL-GRADE.SALON'}">
    </ng-container>

    <ng-container [ngTemplateOutlet]="partialGrade"
                  [ngTemplateOutletContext]="{rating:reviewsSummary.employeesAverageRating,
                    translation: 'SALON-DETAILS.REVIEWS-SECTION.AVERAGE-PARTIAL-GRADE.EMPLOYEES'}">
    </ng-container>

    <ng-container [ngTemplateOutlet]="partialGrade"
                  [ngTemplateOutletContext]="{rating:reviewsSummary.treatmentsAverageRating,
                    translation: 'SALON-DETAILS.REVIEWS-SECTION.AVERAGE-PARTIAL-GRADE.TREATMENTS'}">
    </ng-container>

  </div>
</div>

<ng-template #partialGrade
             let-rating="rating"
             let-translation="translation">
  <div class="d-flex flex-row align-items-center mb-2">
    <div class="d-flex flex-even justify-content-between align-items-center">
      <span class="flex-even partial-grade"
            [translate]="translation">
      </span>
    </div>
    <div class="flex-even d-flex flex-row align-items-center">
      <span class="me-2 h6 fw-bold mb-0">{{rating | number: '1.1-1'}}</span>
      <app-rating-bar class="flex-even"
                      [ratingValue]="rating">
      </app-rating-bar>
    </div>
  </div>
</ng-template>
